import { render } from "./ModalPartners.vue?vue&type=template&id=59fcf9e4"
import script from "./ModalPartners.vue?vue&type=script&lang=js"
export * from "./ModalPartners.vue?vue&type=script&lang=js"

import "./ModalPartners.vue?vue&type=style&index=0&id=59fcf9e4&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__